import { z } from 'zod';

/**
 * Workflow input. Loose objects: fields autopilot adds later are preserved, not rejected.
 * Autopilot reads only `quoteNumber` (a quote OR policy number, matched exactly and
 * case-sensitively after trimming); `requestId`, `requestedBy`, `note` and `options` are accepted
 * and ignored.
 */
export const adhocSubmissionInputSchema = z.looseObject({
  quoteNumber: z.string().min(1),
  requestId: z.string().min(1),
  requestedBy: z.looseObject({ sub: z.string().min(1), email: z.string() }),
  note: z.string().optional(),
  options: z.record(z.string(), z.unknown()).optional(),
});
export type AdhocSubmissionInput = z.infer<typeof adhocSubmissionInputSchema>;
